import { ParticipantStepState, } from '@wix/ambassador-challenges-v1-participant/types';
export function isParticipateStepQuizFailed(step) {
    return (step.transitions[0].state === ParticipantStepState.RUNNING &&
        step.quizSubmission?.quizSubmissionId);
}
export const patchParticipantStep = (step) => {
    if (isParticipateStepQuizFailed(step)) {
        return {
            ...step,
            transitions: [
                {
                    state: ParticipantStepState.FAILED,
                    occurredAt: step.transitions[0].occurredAt,
                },
                ...step.transitions,
            ],
        };
    }
    return step;
};
export function patchParticipantStepList(steps) {
    return steps.map(patchParticipantStep);
}
export function patchParticipantSectionList(_sections) {
    return _sections.map((section) => ({
        ...section,
        steps: patchParticipantStepList(section.steps),
    }));
}
//# sourceMappingURL=patchServerEntities.js.map